import type { AnswersRequest, QuestionApi } from '@webapp/survey/src/api/queries-api';
import type { ResponseEventParams } from '@webapp/survey/src/entities/response-machine';
import type { QuestionActor, QuestionContext } from '@webapp/survey/src/machine/question-machine';

export abstract class ListApi implements QuestionApi {
    public abstract change(question: QuestionContext, evt: ResponseEventParams): void;

    public changeExtra(q: QuestionActor, value: PrimitiveValue): void {
        const responseActor = q.getSnapshot().context.response;
        responseActor.send({ type: 'CHANGE_EXTRA', value });

        if (value) {
            responseActor.send({ type: 'CHANGE', value: !!value, questionId: q.getSnapshot().context.id });
        }
    }

    public abstract query(q: QuestionActor): AnswersRequest;

    public validate({ answers, params: { required } }: QuestionContext): boolean {
        if (required) {
            answers.forEach(({ response }) => !!response);
        }

        return true;
    }
}
